import { createClient } from '@supabase/supabase-js'
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/etc/env'

// Create a single supabase client for interacting with your database
const supabase = createClient(SUPABASE_URL || 'http://qwe:9000', SUPABASE_ANON_KEY || 'asd')

export default supabase
